import { useQueryClient } from '@tanstack/react-query';
import { useCallback } from 'react';
import { isInternalQueryKey } from '@lifeomic/one-query/util';
import { Folder, ModelUtils, TemplatingItem } from '../models';
import { AI_TEMPLATES_ROUTE_QUERY_KEY } from './useTemplatingItemSummaries';

type TemplatingItemOrFolder = TemplatingItem | Folder;

const getPrefixes = (templatingItems: TemplatingItemOrFolder[]) => {
  const prefixes = new Set<string>();
  templatingItems.forEach(item => {
    if (item?.type === 'folder') {
      prefixes.add(item.path);
    } else {
      prefixes.add(ModelUtils.getParentFolder(item).path);
    }
  });
  return prefixes;
};

export const useInvalidateTemplatingItems = () => {
  const queryClient = useQueryClient();
  return useCallback(
    (...templatingItems: TemplatingItemOrFolder[]) => {
      const prefixes = getPrefixes(templatingItems);
      for (const prefix of prefixes) {
        queryClient.invalidateQueries({
          predicate: query => {
            const internalQueryKey = query.queryKey.find(isInternalQueryKey);
            if (!internalQueryKey) {
              return false;
            }
            if (internalQueryKey.route !== AI_TEMPLATES_ROUTE_QUERY_KEY) {
              return false;
            }
            const payload = internalQueryKey.payload as { prefix: string };
            return (payload.prefix ?? '') === prefix;
          },
        });
      }
    },
    [queryClient],
  );
};
